import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslationService } from '../../core/services/translation.service';

/**
 * Translate pipe for i18n support
 *
 * Usage:
 *   {{ 'key.name' | translate }}
 *   {{ 'welcome.message' | translate:{ name: userName } }}
 *   <button [attr.aria-label]="'button.close' | translate">X</button>
 *
 * Features:
 * - Returns translated string or key if not found (graceful degradation)
 * - Supports parameter substitution
 * - Pure pipe for performance (caching)
 * - Debug mode logs missing keys
 */
@Pipe({
  name: 'translate',
  pure: true,
  standalone: true
})
export class TranslatePipe implements PipeTransform {
  private translationService = inject(TranslationService);
  private sanitizer = inject(DomSanitizer);

  /**
   * @param key Translation key
   * @param params Optional parameters for substitution
   * @returns string
   */
  transform(key: string, params?: Record<string, string>): string {
    return this.translationService.translate(key, params);
  }


  // Only one transform method supporting markdown
}
